import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLoginModal } from '../context/LoginModalContext';
import { useAuth } from '../context/AuthContext';
import LoginForm from './LoginForm';

export default function LoginModal() {
  const { t } = useTranslation();
  const { isOpen, closeLogin } = useLoginModal();
  const { user } = useAuth();

  useEffect(() => {
    if (user && isOpen) closeLogin();
  }, [user, isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    document.body.style.overflow = 'hidden';
    const onKeyDown = e => { if (e.key === 'Escape') closeLogin(); };
    window.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={closeLogin}>
      <div className="modal-card auth-card" onClick={e => e.stopPropagation()}>
        <button type="button" className="modal-close" onClick={closeLogin} aria-label={t('login.closeLogin')}>✕</button>
        <LoginForm onSuccess={closeLogin} recaptchaContainerId="recaptcha-container-modal" />
      </div>
    </div>
  );
}
